export const getUserSettingsFromState = {
  DefaultSearchCategories: 'defaultSearchCategories',
  DisplayBoolErrorMessage: 'displayBoolErrorMessage',
  DisplayPhraseErrorMessage: 'displayPhraseErrorMessage',
  ExcludePreviouslyExportedEmailsByDefault:
    'excludePreviouslyExportedEmailsByDefault',
  ExcludeFromExportTabsWithNoResults: 'excludeFromExportTabsWithNoResults',
};

export const getUserSettingsFromUrl = {
  CanPushBlankEmails: 'CanPushBlankEmails',
};

export const userSettingToStringMap = {
  [getUserSettingsFromUrl.CanPushBlankEmails]: 'Can Push Blank Emails',
  [getUserSettingsFromState.DisplayBoolErrorMessage]:
    'Display Boolean Error Message',
  [getUserSettingsFromState.DisplayPhraseErrorMessage]:
    'Display Phrase Error Message',
  [getUserSettingsFromState.DefaultSearchCategories]:
    'Change Default Categories For Search',
  [getUserSettingsFromState.ExcludePreviouslyExportedEmailsByDefault]:
    'Exclude Previously Exported Emails by Default',
  [getUserSettingsFromState.ExcludeFromExportTabsWithNoResults]:
    'Exclude From Export Tabs With No Results',
};

export const userSettingsValidation = {
  [getUserSettingsFromUrl.CanPushBlankEmails]: u => {
    return (
      u.isAccountManager &&
      (u.canPushToSalesforce || u.canPushToHubspot || u.canPushToDynamics)
    );
  },
};

export const GetValidatedUserSettings = (userSettings, user) => {
  let retUserSettings = [];
  for (var setting in userSettings) {
    if (
      userSettingsValidation[setting] === undefined ||
      (userSettingsValidation[setting] !== undefined &&
        userSettingsValidation[setting](user))
    ) {
      retUserSettings.push(setting);
    }
  }
  return retUserSettings;
};
